import React, {Component} from 'react';
import {Toast, Button, TextField, Card, Layout, DataTable, Pagination, Spinner, EmptyState, SkeletonBodyText, } from '@shopify/polaris';
import '@shopify/polaris/styles.css';
import './home.css';
import {reqConversionsInfo, reqConversionsList} from "../../api/index";
import memory from '../../utils/memory';
import { Redirect } from 'react-router-dom';
import copy from 'copy-to-clipboard';
import not_found from '../../assets/not_found.png';

export default class Home extends Component{
    constructor(props) {
        super(props);
        this.state = {
            user_info:memory.user_info,
            isLoading:true,
            conversions_info:{},
            rows:[],
            response_data:[],
            offset:1,
            hasPrevious:false,
            hasNext:false,
            toast_active:false,
            toase_duration:1500,
            total_num:0,
            install_date_order:'asc',
            to:0
        }
    }

    fetchData = (sort_order) =>{
        reqConversionsList(this.state.offset, sort_order).then(
            response => {
                let rows = [];
                let response_data  = response.data.success.data;
                for (let index = 0; index < response_data.length; index++) {
                    let items = [];
                    items.push(((this.state.offset - 1) * 10) + index + 1);
                    items.push(response_data[index].shop_url);
                    items.push(response_data[index].created_at);
                    items.push(response_data[index].shopify_plan );
                    items.push(response_data[index].parcelpanel_plan_title);
                    rows.push(items)
                }

                let hasPrevious = response.data.success.prev_page_url === null ? false : true;
                let hasNext     = response.data.success.next_page_url === null ? false : true;
                let to          = response.data.success.to === null ? 0 : response.data.success.to;
                this.setState({response_data:response.data.success,rows:rows, to:to, isLoading:false, hasPrevious:hasPrevious, hasNext:hasNext, total_num:response.data.success.total_num});
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    componentDidMount() {
        this.fetchData('asc');
        reqConversionsInfo().then(
            response => {
                this.setState({conversions_info:response.data.success, isLoading:false});
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    next = () =>{
        this.setState({offset:this.state.offset + 1}, this.fetchData);
    }

    prev = () =>{
        this.state.offset > 1 && this.setState({offset:this.state.offset - 1}, this.fetchData);
    }

    copyLink = () =>{
        this.setState({toast_active:true});
        copy(this.state.user_info.affiliate_link);
    }

    onDismiss = () =>{
        this.setState({toast_active:!this.state.toast_active});
    }

    sort = ()=> {
        let sort_order = this.state.install_date_order === 'asc' ? 'desc' : 'asc';
        this.setState({install_date_order:sort_order});
        this.fetchData(sort_order);
    }

    render () {

        const toastMarkup = this.state.toast_active ? (
            <Toast content="link copied" onDismiss={this.onDismiss} duration={this.state.duration} />
          ) : null;
        
        if(memory.user_info === '{}')
        {
            return <Redirect to="/login" />
        }

        let conversions_info = this.state.conversions_info
        
        //定义空值状态
        let empty_state = '';

        if (this.state.response_data.length !==0 && this.state.total_num === 0 ) {
            empty_state = <EmptyState heading="No data" image={not_found} ></EmptyState>;
        }

        //定义spinner
        let conversion_spinner = <div className="conversion_spinner">
            <Spinner accessibilityLabel="Spinner example" size="large" color="teal" />
        </div>

        if (this.state.response_data.length !==0) {
            conversion_spinner = '';
        }


        const conversion_tabel = 
        <div className="conversions">
            <Card>
                <DataTable
                columnContentTypes={[
                    'text',
                    'numeric',
                    'text',
                    'text',
                    'text',
                ]}
                headings={[
                    'ID',
                    'Store URL',
                    'Install date',
                    'Shopify plan',
                    'App plan',
                ]}
                rows={this.state.rows}
                sortable={[false, false, true, false, false]}
                onSort={this.sort}
                />

                {conversion_spinner}
                {empty_state}
                
                <Card.Section>
                    <div className="pagination-section">
                        <span className="pagination-text">{`Showing ${this.state.to} of ${this.state.total_num} results`}</span>
                        <Pagination
                            hasPrevious={this.state.hasPrevious}
                            onPrevious={this.prev}
                            hasNext={this.state.hasNext}
                            onNext={this.next}
                        />
                    </div>
                </Card.Section>

            </Card>

        </div>

        
        //给一个加载效果
        let total_installed_body = <SkeletonBodyText lines={3} />;

        if (conversions_info.total_installed !== undefined) {
            total_installed_body = <p>
                <span>{conversions_info.total_installed}</span>
                <span>Total installed</span>
            </p>
        }

        let total_subscript_body = <SkeletonBodyText lines={3} />;

        if (conversions_info.total_subscript !== undefined) {
            total_subscript_body = <p>
                <span>{conversions_info.total_subscript}</span>
                <span>Total subscript</span>
            </p>
        }

        let total_uninstalled_body = <SkeletonBodyText lines={3} />;

        if (conversions_info.total_uninstalled !== undefined) {
            total_uninstalled_body = <p>
                <span>{conversions_info.total_uninstalled}</span>
                <span>Total uninstalled</span>
            </p>
        }

        

        return (
            <div className="home">
                {toastMarkup}
                <Layout>
                    <Layout.Section>
                        <h1>Your referral link</h1>
                        <TextField type="text" value={this.state.user_info.affiliate_link} connectedRight={<Button onClick={this.copyLink} primary>Copy</Button>}/>
                    </Layout.Section>
                </Layout>

                {/* <SkeletonPage primaryAction secondaryActions={2}> */}
                <div className="total-number-section">
                    <Layout>
                        <Layout.Section>
                            <h1>Total number</h1>
                        </Layout.Section>
                    </Layout>

                    <Layout> 
                        <Layout.Section oneThird>
                            <Card sectioned>
                            <div className="data-number">
                                {total_installed_body}
                            </div>
                            </Card>
                        </Layout.Section>

                        <Layout.Section oneThird>
                            <Card sectioned>
                            <div className="data-number">
                                {total_subscript_body}
                            </div>
                            </Card>
                        </Layout.Section>

                        <Layout.Section oneThird>
                            <Card sectioned>
                            <div className="data-number">
                                {total_uninstalled_body}
                            </div>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </div>
                {/* </SkeletonPage> */}

                <div className="referrals-section">
                    <Layout>
                        <Layout.Section>
                            <h1>Your referrals</h1>
                            {conversion_tabel}
                        </Layout.Section>
                    </Layout>
                </div>
            </div>

        )
    }
}

